import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

export const BackButtonWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})<{ fontSize?: number | string }>(({ fontSize, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  fontWeight: 500,
  fontSize: fontSize ? fontSize : '2rem',
  padding: 10,

  '& .title': {
    display: 'flex',
    cursor: 'pointer',
  },
  '& .parent': {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[500],
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32.02px',

    '& .MuiSvgIcon-root': {
      marginRight: '12px',
    },
  },
}))

export const StyledSpan = styled(Typography)(({ theme }) => ({
  marginLeft: 8,
  color: theme.palette.primary.main,
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '32.02px',
  '&.haslink': {
    cursor: 'pointer',
  },
}))
